import clsx from 'clsx';
import { KTSVG } from '../../../helpers';
import { useThemeMode } from './ThemeModeProvider';

const ThemeModeSwitcher = ({ 
    toggleBtnClass = '', 
    toggleBtnIconClass = 'svg-icon-2', 
    menuPlacement = 'bottom-end', 
    menuTrigger = "{default: 'click', lg: 'hover'}", 
}) => {
    const { menuMode, updateMenuMode, updateMode } = useThemeMode();
    
    const switchMode = () => {
        updateMenuMode('light');
        updateMode('light');
    };

    return (
        <>
            {/* begin::Menu toggle */}
            {/* <a href='#' 
               className={clsx('btn btn-icon', toggleBtnClass)} 
               data-kt-menu-trigger={menuTrigger} 
               data-kt-menu-attach='parent' 
               data-kt-menu-placement={menuPlacement}>
                <KTSVG path='/media/icons/duotune/general/gen060.svg' className={clsx('theme-dark-hide', toggleBtnIconClass)}/>
            </a> */}
            {/* end::Menu toggle */}

            {/* begin::Menu */}
            {/* <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px' data-kt-menu='true'>
              
                <div className='menu-item px-3 my-0'>
                    <a href='#' className={clsx('menu-link px-3 py-2', { active: menuMode === 'light' })} onClick={switchMode}>
                        <span className='menu-icon' data-kt-element='icon'>
                            <KTSVG path='/media/icons/duotune/general/gen060.svg' className='svg-icon-3'/>
                        </span>
                        <span className='menu-title'>Light</span>
                    </a>
                </div>
       
            </div> */}
            {/* end::Menu */}
        </>
    );
};

export { ThemeModeSwitcher };
